import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useMastheadTracking } from "scmp-app/components/header/hooks";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import { page as SearchPage } from "scmp-app/pages/search";

import { Container, StyledBaseLink, StyledIconSearch } from "./styles";

export type HeaderFeaturesSearchProps = HeaderFeatureCommonProps & {
  showDesktopDivider?: boolean;
};

export const HeaderFeaturesSearch: FunctionComponent<HeaderFeaturesSearchProps> = ({
  showDesktopDivider = false,
  ...props
}) => {
  const handleSearchClick = () => {
    // GA4 21.1.1
    sendGA4Tracking({
      action: "click",
      category: "search",
      subcategory: "icon",
    } as SearchEvent);
  };

  const { pathname: searchPathname, query: searchQuery } = SearchPage.route({});
  const mastheadQueryParameter = useMastheadTracking();

  return (
    <Container $showDesktopDivider={showDesktopDivider} {...getResponsiveProps(props)}>
      <StyledBaseLink
        anchorProps={{ "aria-label": "search" }}
        as="/search"
        onClick={handleSearchClick}
        pathname={searchPathname}
        query={{ ...searchQuery, ...mastheadQueryParameter }}
      >
        <StyledIconSearch />
      </StyledBaseLink>
    </Container>
  );
};

HeaderFeaturesSearch.displayName = "HeaderFeaturesSearch";
